<template>
  <div class="email-settings">
    <section class="section header-settings">
      <div class="header-content">
        <div class="header-titles">
          <h1 class="title is-3">Configuración de Correos</h1>
          <p class="subtitle">
            Personaliza las plantillas de correo para cada módulo de
            diagnóstico.
          </p>
        </div>

        <!-- Selector de contexto - solo visible para admin -->
        <div v-if="isAdmin" class="context-selector">
          <span class="context-label">Editando plantillas para</span>
          <div class="context-dropdown-wrapper">
            <b-dropdown
              v-model="selectedContext"
              aria-role="list"
              position="is-bottom-left"
            >
              <template #trigger>
                <button
                  class="context-button"
                  :class="{ 'is-global': selectedContext === 'global' }"
                >
                  <span v-if="selectedContext === 'empresa'">
                    🏢 {{ company.nombre }}
                  </span>
                  <span v-else>
                    🌐 Plantillas Globales
                  </span>
                  <i class="material-icons">expand_more</i>
                </button>
              </template>

              <b-dropdown-item value="empresa" aria-role="listitem">
                <div class="dropdown-option">
                  <span class="option-icon">🏢</span>
                  <div class="option-text">
                    <span class="option-title">{{ company.nombre }}</span>
                    <span class="option-subtitle">Solo para esta empresa</span>
                  </div>
                </div>
              </b-dropdown-item>

              <hr class="dropdown-divider" />

              <b-dropdown-item value="global" aria-role="listitem">
                <div class="dropdown-option">
                  <span class="option-icon">🌐</span>
                  <div class="option-text">
                    <span class="option-title">Plantillas Globales</span>
                    <span class="option-subtitle"
                      >Default para todas las empresas</span
                    >
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <span v-if="selectedContext === 'global'" class="admin-badge">
              ADMIN
            </span>
          </div>
        </div>
      </div>
    </section>

    <div class="tab-menu-settings">
      <nav class="tabs is-boxed tabs-on-card-settings">
        <ul>
          <li
            v-for="(item, index) in moduleList"
            :key="item.key"
            :class="{ 'is-active': activeModule === item.key }"
            :style="index === 0 ? 'margin-left: 50px;' : ''"
            @click="activeModule = item.key"
          >
            <a href="javascript:void(0)">
              <i class="material-icons">{{ item.icon }}</i>
              <span>{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </nav>

      <div class="tab-card-settings">
        <EmailTemplateEditor
          v-if="company && company._id"
          :key="activeModule + '-' + selectedContext"
          :module="activeModule"
          :clienteId="effectiveClienteId"
          :procesoId="null"
        />

        <div v-else class="notification is-warning">
          <p>Cargando información de empresa...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmailTemplateEditor from "@/components/shared/emailEditor/components/EmailTemplateEditor.vue";

export default {
  name: "EmailSettings",
  components: {
    EmailTemplateEditor,
  },
  data: function() {
    return {
      activeModule: "liderazgo",
      selectedContext: "empresa",
      moduleList: [
        { key: "liderazgo", label: "Liderazgo", icon: "stars" },
        { key: "clima", label: "Clima", icon: "ac_unit" },
        { key: "cultura", label: "Cultura", icon: "stream" },
        {
          key: "usuarios",
          label: "Usuarios/Plataforma",
          icon: "manage_accounts",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      company: "empresa",
      tokenUser: "tokenUser",
    }),
    isAdmin: function() {
      return this.tokenUser && this.tokenUser.admin === true;
    },
    effectiveClienteId: function() {
      if (this.selectedContext === "global") {
        return null;
      }
      return this.company && this.company._id ? this.company._id : null;
    },
  },
};
</script>

<style>
.email-settings .header-settings {
  min-height: 96px;
  padding: 1.5rem 3rem !important;
  background-color: #f5f5f5;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
}

.header-titles {
  flex: 1;
}

.header-titles .title {
  margin-bottom: 8px !important;
  line-height: 1.2;
}

.header-titles .subtitle {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  line-height: 1.4;
}

.tab-menu-settings {
  padding: 0 0 3rem;
}

.tab-menu-settings .tabs-on-card-settings {
  margin-bottom: 0 !important;
  padding: 0.5rem 0 0;
  background-color: #f5f5f5;
}

.tab-menu-settings .tabs-on-card-settings ul {
  border-bottom: none !important;
}

.tab-menu-settings .tabs-on-card-settings.is-boxed li a {
  border: 0px solid transparent !important;
  border-radius: 4px 4px 0 0 !important;
  background-color: transparent;
  color: #4a4a4a;
  margin-bottom: 0;
  transition: background-color 0.15s ease, color 0.15s ease;
  display: flex;
  align-items: center;
}

.tab-menu-settings .tabs-on-card-settings.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.tab-menu-settings .tabs-on-card-settings.is-boxed li.is-active a {
  background-color: #fff;
  border: solid 0 #fff !important;
  color: #522687 !important;
  font-weight: 600;
  box-shadow: #00000029 0px 14px 20px;
}

.tab-menu-settings .tabs-on-card-settings.is-boxed li a .material-icons {
  font-size: 18px;
  margin-right: 0.4em;
}

.tab-menu-settings .tab-card-settings {
  padding: 1.5rem 3rem 0;
}

/* Selector de contexto */
.context-selector {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.context-label {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.context-dropdown-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.context-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 200px;
  justify-content: space-between;
}

.context-button:hover {
  border-color: #522687;
}

.context-button.is-global {
  background: #f3e8ff;
  border-color: #c4b5fd;
  color: #522687;
}

.context-button .material-icons {
  font-size: 20px;
  color: #9ca3af;
}

.context-button.is-global .material-icons {
  color: #522687;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}

/* Estilo para opción seleccionada en dropdown */
.context-selector a.dropdown-item.is-active,
.context-selector a.dropdown-item:focus,
.context-selector .dropdown-content a.is-active {
  background-color: #f3e8ff !important;
  color: #522687 !important;
}

.context-selector a.dropdown-item.is-active .option-title,
.context-selector a.dropdown-item:focus .option-title,
.context-selector .dropdown-content a.is-active .option-title {
  color: #522687 !important;
}

.context-selector a.dropdown-item.is-active .option-subtitle,
.context-selector a.dropdown-item:focus .option-subtitle,
.context-selector .dropdown-content a.is-active .option-subtitle {
  color: #7c3aed !important;
}

.option-icon {
  font-size: 18px;
}

.option-text {
  display: flex;
  flex-direction: column;
}

.option-title {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.option-subtitle {
  font-size: 12px;
  color: #9ca3af;
}

.admin-badge {
  background: #522687;
  color: white;
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive móvil */
@media (max-width: 768px) {
  .email-settings .header-settings {
    padding: 1rem 1.5rem !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .context-selector {
    align-items: flex-start;
    width: 100%;
  }

  .context-button {
    width: 100%;
  }

  .tab-menu-settings .tab-card-settings {
    padding: 1rem !important;
  }

  /* Tabs de módulos: solo iconos en móvil */
  .tab-menu-settings .tabs-on-card-settings li a span {
    display: none;
  }

  .tab-menu-settings .tabs-on-card-settings li a .material-icons {
    margin-right: 0 !important;
    font-size: 22px;
  }

  .tab-menu-settings .tabs-on-card-settings li a {
    padding: 10px 16px;
  }

  .tab-menu-settings .tabs-on-card-settings li:first-child {
    margin-left: 1.5rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/views/EmailSettings.vue